'use client'

import React, { FC, ReactElement } from 'react'
import styles from './InscriptionActionView.module.css'
import ButtonAction from '@/components/button-action'
import NFTIcon from '@/icons/nft'
import useInscriptionModal from '@/utils/hooks/useInscriptionModal'

const InscriptionActionView: FC<{ id: string }> = (props): ReactElement => {
	const openInscriptionModal = useInscriptionModal()
	return (
		<ButtonAction
			background="black"
			handleClick={() => openInscriptionModal({ id: props.id })}
			icon={() => <NFTIcon className={styles.icon} />}
			title="View item"
		/>
	)
}

export default InscriptionActionView
